import React, { useState, useEffect } from "react";
import { mediaUrl } from "../../../helpers/CoreHelpers";
import * as Styled from "./misc/styled";
import sortBy from "lodash/sortBy";

const CardGrid = ({
  category,
  title,
  description,
  cards,
  pageSize,
  renderSrcDirectly = false,
}) => {
  const [visibleCards, setVisibleCards] = useState([]);
  const [remainingCards, setRemainingCards] = useState([]);

  useEffect(() => {
    const remaining = [...cards];
    const append = remaining.splice(0, pageSize);
    setVisibleCards(append);
    setRemainingCards(remaining);
  }, [cards, pageSize]);

  const handleShowMore = (e) => {
    e.preventDefault();
    const remaining = [...remainingCards];
    const append = remaining.splice(0, pageSize);
    setVisibleCards([...visibleCards, ...append]);
    setRemainingCards(remaining);
  };

  return (
    <Styled.CardGridContainer>
      <p className="category">{category}</p>
      <h4 className="title">{title}</h4>
      <p className="description">{description}</p>
      <Styled.Grid>
        {sortBy(visibleCards, ["order", "title", "description"]).map((o) => (
          <Styled.Card
            key={o.id}
            imgSrc={renderSrcDirectly ? o.imgSrc : mediaUrl(o.imgSrc)}
            renderSrcDirectly={renderSrcDirectly}
          >
            <div className="cover" />
            <div className="card-content">
              <div className="body">
                <p className="title">{o.title}</p>
                <p className="description">
                  <a href={o.link} target="_blank" className="link">
                    {o.description}
                  </a>
                </p>
                {
                  o.subText && <p className="subtext">{o.subText}</p>
                }
              </div>
              <div className="footer">
                <a className="link" href={o.link} target="_blank">
                  {o.btnText}
                </a>
              </div>
            </div>
          </Styled.Card>
        ))}
      </Styled.Grid>
      {remainingCards.length > 0 && (
        <Styled.ShowMore>
          <button onClick={handleShowMore}>Show more</button>
        </Styled.ShowMore>
      )}
    </Styled.CardGridContainer>
  );
};

export default CardGrid;



// WEBPACK FOOTER //
// ./src/core/admin/components/CardGrid/CardGrid.js